var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9705 22.4273V3.42554",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3992 37.6955H37.144L35.7342 34.6913L33.638 39.1981L30.9702 32.3452L28.3404 37.6955H24.4152",
    stroke: "#CE1111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4708 22.4279C13.3957 11.6696 18.2158 3.42554 23.9983 3.42554C29.7807 3.42554 34.5459 11.6696 35.4703 22.4279",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9366 22.3827C45.6435 20.6314 43.5648 19.4946 41.2199 19.4946C38.8551 19.4946 36.7606 20.65 35.4697 22.4274C34.1794 20.65 32.0849 19.4946 29.7201 19.4946C27.9439 19.4946 26.32 20.1471 25.075 21.2249C24.9804 21.3065 24.8881 21.3909 24.7986 21.4776C24.4956 21.7687 24.218 22.0864 23.97 22.4274C23.7219 22.0859 23.4449 21.7687 23.1413 21.4776C23.0518 21.3909 22.9595 21.3071 22.8649 21.2249C21.6194 20.1471 19.9961 19.4946 18.2192 19.4946C15.8551 19.4946 13.7593 20.65 12.4696 22.4274C11.1782 20.65 9.08422 19.4946 6.72004 19.4946C4.37455 19.4946 2.29584 20.6314 1.0033 22.3827C2.78974 11.9693 11.8211 3.95464 22.8649 3.45054C22.9567 3.44601 23.049 3.44204 23.1413 3.43921C23.4166 3.42901 23.6924 3.42505 23.97 3.42505C24.2475 3.42505 24.5233 3.42958 24.7986 3.43921C24.8909 3.44204 24.9833 3.44601 25.075 3.45054C36.1183 3.95464 45.1496 11.9699 46.9366 22.3827Z",
    stroke: "#CE1111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7986 2.35673V3.4397C24.5233 3.4295 24.2475 3.42554 23.9699 3.42554C23.6924 3.42554 23.4166 3.43007 23.1413 3.4397V2.35673C23.1413 1.89907 23.5123 1.52808 23.9699 1.52808C24.4276 1.52808 24.7986 1.89907 24.7986 2.35673Z",
    stroke: "#CE1111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7986 21.4775V26.7904C24.3642 27.0527 23.9541 27.371 23.5797 27.7454C23.4812 27.844 23.386 27.9453 23.2965 28.049C23.2433 28.109 23.1923 28.1708 23.1419 28.2325V21.4775C23.4449 21.7687 23.7225 22.0864 23.9706 22.4274C24.2181 22.0864 24.4956 21.7687 24.7986 21.4775Z",
    stroke: "#CE1111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5797 36.848L24.7986 38.067V44.9125C24.7986 46.8542 23.2433 48.4662 21.3016 48.4718C20.3291 48.4747 19.4489 48.0816 18.8117 47.4444C18.1773 46.81 17.7842 45.9332 17.7842 44.9647V44.4758C17.7842 44.0182 18.1552 43.6472 18.6129 43.6472C19.0706 43.6472 19.4415 44.0182 19.4415 44.4758V44.9273C19.4415 45.9389 20.2379 46.7919 21.2495 46.814C21.7768 46.8259 22.2555 46.6163 22.5998 46.2725C22.9346 45.9372 23.1419 45.475 23.1419 44.9641V36.3638C23.2784 36.5303 23.424 36.6923 23.5797 36.848Z",
    stroke: "#CE1111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.059 36.8481L34.3193 47.5883L27.1436 40.4119L23.5797 36.8481C23.424 36.6924 23.2784 36.5304 23.1419 36.3638C21.2229 34.0093 21.2224 30.5871 23.1419 28.2325C23.1923 28.1708 23.2433 28.1096 23.2965 28.049C23.386 27.9453 23.4817 27.8434 23.5797 27.7454C23.9541 27.371 24.3642 27.0527 24.7986 26.7904C25.527 26.3509 26.3257 26.0688 27.1436 25.9431C27.4704 25.8921 27.8006 25.8672 28.1308 25.8672C29.7802 25.8672 31.4307 26.4936 32.6824 27.7448L34.3188 29.3817L35.9557 27.7448C38.4592 25.2419 42.5554 25.2419 45.0584 27.7448C47.5625 30.2489 47.5625 34.3452 45.059 36.8481Z",
    stroke: "#CE1111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 32.6384V36.7647H11.0791V41.885H6.95226V36.7647H1.83252V32.6384H6.95226V27.5176H11.0791V32.6384H16.2Z",
    stroke: "#CE1111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthInsurance);
export default __webpack_public_path__ + "static/media/health_insurance.3e7e5d4369243a896243b4500d6bf467.svg";
export { ForwardRef as ReactComponent };